import axios from 'axios'
import { resolveNppvApiUri } from '@/utils/nppv-config'

const service = axios.create({
  baseURL: resolveNppvApiUri(process.env.VUE_APP_NPPV_API_URI),
  withCredentials: false,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

service.interceptors.response.use(
  response => response.data,
  error => Promise.reject(new Error(error?.response?.data?.msg || error?.message || '网络异常'))
)

export const nppvHttp = {
  get (url, params) {
    return service.get(url, { params })
  },
  post (url, data) {
    return service.post(url, data)
  }
}

export default service
